import { css } from '@emotion/css';
import { Spacing } from '@snapchat/snap-design-system';

export const nameInputClassName = css({
  marginBottom: Spacing.SM,
});
